import transfer from './index';
import transferAll from './TransferAll';
import transferInner from './TransferInner';
import transferCoinSet from './TransferCoinSet';
import transferQuery from './TransferAll/transferQuery';
import transferColdWallet from './transferColdWallet';
import transferShiZhiQuery from './transferShiZhiQuery';
import transferPsi from './TransferPsi';
import transferPsiSettle from './TransferPsiSettle'

export default {
    path: '/home/transfer',
    component: transfer,
    children: [
        { path: '/home/transfer/inner', component: transferInner },
        { path: '/home/transfer/all', component: transferAll },
        { path: '/home/transfer/coin/set', component: transferCoinSet },
        { path: '/home/transfer/query', component: transferQuery },
        { path: '/home/transfer/transferShiZhiQuery', component: transferShiZhiQuery },
        { path: '/home/transfer/cold/wallet', component: transferColdWallet },
        { path: '/home/transfer/psi', component: transferPsi },
        { path: '/home/transfer/psiSettle', component: transferPsiSettle }
    ]
}